export default {
    se360Users: {
        list: [],
        view: {},
        new: {
            availableRoles: [],
            avaiableLanguages: [],
            availableCountries: []
        },
        edit: {
            user: {},
            availableRoles: [],
            avaiableLanguages: [],
            availableCountries: []
        }
    }
};
